import { Center, Spinner } from '@chakra-ui/react'
import { usePropertyDetailsStore } from 'features/PropertyDetails/infra/react/usePropertyDetailsState'
import { toast } from 'presentation/components/Toast'
import { useLayoutStore } from 'presentation/layouts/Layout/hooks/useLayoutStore'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const PropertyDetailsFromParcelIdScreen = () => (
  <PropertyDetailsFromParcelIdScreenDumb />
)

export const PropertyDetailsFromParcelIdScreenDumb = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const getProperty = usePropertyDetailsStore(state => state.actions.getProperty)

  const parcelId = searchParams.get('parcelId')

  // Request property or redirect, depending on address completeness
  useEffect(() => {
    if (!parcelId)
      navigate('/search')
    else
      void getProperty.execute({ parcelId, origin: 'other' })
  }, [])

  // Redirect in reaction to property request state
  const state = getProperty.state
  useEffect(() => {
    if (!('params' in state)) return
    if (!('parcelId' in state.params)) return
    if (state.params.parcelId !== parcelId) return

    if (state.status === 'success') {
      navigate(`/search/${state.data.leadId}`, { replace: true })
    } else if (state.status === 'error') {
      navigate('/search')
      toast.error({
        title: 'Failed to Load Property Data',
        message: 'Please try again or contact support.',
      })
    }
  }, [state])

  return <Loading />
}

const Loading = () => {
  const height = useLayoutStore(store => store.totalBodyHeight)

  return (
    <Center h={height}>
      <Spinner />
    </Center>
  )
}
